.loginButton {
    margin-left: 10px;
}
